import React, { useState } from "react";
import { cn } from "../../../shared/utils/cn";

interface Props extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  variant?: "primary" | "admin";
  inputClassName?: string;
  error?: {
    message: string;
    isMessageVisible: boolean;
    isIconVisible: boolean;
  };
  rows?: number;
}

const TextArea: React.FC<Props> = ({
  variant = "primary",
  maxLength,
  placeholder,
  className,
  inputClassName = "",
  id,
  error,
  rows,
  ...props
}) => {
  const baseClass = "flex flex-row justify-between border";

  const variantClasses = {
    div: {
      primary:
        "bg-white rounded-[8px] border border-separate border-tools-table-outline p-3",
      admin: "rounded-[8px] p-[11.5px] bg-transparent",
    },
    input: {
      primary: "w-full / text-sm / bg-white",
      admin: "bg-transparent w-full text-[14px] outline-none",
    },
  };

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`text-start flex flex-col ${className}`}>
      <div
        className={`relative
        ${baseClass} ${cn(variantClasses.div[variant])}
        ${error?.message ? "border-[#F24A4A]" : ""}
        ${error?.message ? "border-[#F24A4A]" : ""}
        ${isFocused && !error?.message ? "border-[#4285F4]" : ""}
        ${!isFocused && !error?.message ? "border-[#d9d9d9]" : ""}
        `}
      >
        <textarea
          {...props}
          placeholder={placeholder}
          className={`outline-none ${cn(variantClasses.input[variant])} ${inputClassName}`}
          maxLength={maxLength}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          rows={rows}
        />
        {error?.message && error.isIconVisible ? (
          <div className="flex items-center absolute top-0 bottom-0 right-[0.7188rem]">
            <img
              className="w-[1.2213rem]"
              alt="alert icon"
              src="/assets/icons/alerticon.svg"
            />
          </div>
        ) : null}
      </div>
      {error?.isMessageVisible ? (
        <div className="text-[12px] mt-[0.25rem] text-[#F24A4A]">
          {error?.message}
        </div>
      ) : null}
    </div>
  );
};

export default TextArea;
